import { LenderConfiguration } from '@shared/model/lender-config.model';
import { Component } from '@angular/core';
import { LenderService } from '@shared/service/lender/lender.service';
import { RoutingUrl } from '@shared/constant/route-const';
import { Location } from '@angular/common';

/**
 * Component representing page not found Api call
 * @Component
 */
@Component({
  selector: 'cu-404',
  templateUrl: './404.component.html'
})
/**
 * Class representing page not found Api call
 * @export
 * @class PageNotFoundComponent
 */
export class PageNotFoundComponent {
  public lenderData: LenderConfiguration;
  public defaultRoute = RoutingUrl.Login;
  public dashboardRoute = RoutingUrl.Dashboard;

  constructor(public lenderService: LenderService, private location: Location) {}

  public handleAction(): void {
    // TODO: This reloads the app, need to naviate back without destroying the entire app
    this.location.back();
  }
}
